module.exports = __webpack_public_path__ + "static/img/login_bg.9356af8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/login_bg.jpg
// module id = sxMK
// module chunks = 0